"use strict";

document.addEventListener("DOMContentLoaded", function () {
  (function initFaqBlock() {
    document.addEventListener("click", function (e) {
      if (e.target.closest(".omd-faq-item")) {
        var currentItem = e.target.closest(".omd-faq-item");
        currentItem.classList.toggle("active");
      }
    });
  })();
});